import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-status.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-status.component.scss?ngResource";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input } from "@angular/core";
import { ApplicationSearchConstants } from "../application-search-constants";
import { FormControl, FormGroup } from "@angular/forms";
import { Subject, take } from "rxjs";
import { ApplicationSearchService } from "../../shared/application-search.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { AppControllerService } from "../../../../app-controller.service";
import { AlertType } from "../../../../shared/models/alert";
import { AutoUnsub } from "../../../../shared/decorators/autounsub.decorator";
import { Store } from "@ngrx/store";
import { takeUntil } from "rxjs/operators";
let SearchStatusComponent = class SearchStatusComponent {
    applicationSearchService;
    aflaModuleStrategyService;
    appController;
    store;
    _destroy$ = new Subject();
    statusField;
    statusLabel = ApplicationSearchConstants.FORM_CONTROLS.statusLabel;
    statusFormControl = ApplicationSearchConstants.FORM_CONTROLS.statusFormControl;
    daysUntilExpiredFormControl = ApplicationSearchConstants.FORM_CONTROLS.daysUntilExpiredFormControl;
    placeholder = SharedConstants.SEARCH_BY_DEFAULT;
    searchText = ApplicationSearchConstants.FORM_CONTROLS.searchText;
    isDaysUntilExpiredOption = false;
    percentSign;
    statusForm;
    statusList = [];
    tabChanged;
    applicationSearchCallback;
    getStatusForModuleSubscription;
    constructor(applicationSearchService, aflaModuleStrategyService, appController, store) {
        this.applicationSearchService = applicationSearchService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.store = store;
    }
    ngOnInit() {
        this.setUpForm();
    }
    searchApplication($event) {
        const apps = this.store.select("applicationFormGroup");
        const tabSwitched = this.store.select("applicationTabChanged");
        tabSwitched.pipe(takeUntil(this._destroy$), take(1)).subscribe({
            next: (tab) => {
                this.tabChanged = tab;
            }
        });
        apps.pipe(takeUntil(this._destroy$), take(1)).subscribe(val => {
            if (val != null && this.tabChanged) {
                this.statusForm = val;
            }
        });
        let status = this.statusField === ApplicationSearchConstants.DAYS_UNTIL_EXPIRED
            ? this.statusForm.get(this.daysUntilExpiredFormControl).value
            : this.statusForm.get(this.statusFormControl).value;
        if (this.statusField !== ApplicationSearchConstants.DAYS_UNTIL_EXPIRED && status === "") {
            this.appController.showMessage(`${SharedConstants.NO_OPTION_SELECTED}`, AlertType.Warning);
        }
        else {
            switch (this.statusField) {
                case ApplicationSearchConstants.STATUS:
                    this.applicationSearchCallback(this.applicationSearchService.searchByStatusOrTimeout(Number(this.appController.selectedModuleID), this.aflaModuleStrategyService, -9999, status, "", -9999));
                    break;
                case ApplicationSearchConstants.CATEGORY:
                    this.applicationSearchCallback(this.applicationSearchService.searchByStatusOrTimeout(Number(this.appController.selectedModuleID), this.aflaModuleStrategyService, -9999, status, "", -9999));
                    break;
                case ApplicationSearchConstants.PERCENT_COMPLETE:
                    this.applicationSearchCallback(this.applicationSearchService.searchByStatusOrTimeout(Number(this.appController.selectedModuleID), this.aflaModuleStrategyService, Number(status), "", "", -9999));
                    break;
                case ApplicationSearchConstants.DAYS_UNTIL_EXPIRED:
                    if (!Number.isInteger(status))
                        status = 0;
                    this.applicationSearchCallback(this.applicationSearchService.searchByStatusOrTimeout(Number(this.appController.selectedModuleID), this.aflaModuleStrategyService, -9999, "", "", Number(status)));
                    break;
                case ApplicationSearchConstants.TIMEOUT_STATUS:
                    this.applicationSearchCallback(this.applicationSearchService.searchByStatusOrTimeout(Number(this.appController.selectedModuleID), this.aflaModuleStrategyService, -9999, "", status, -9999));
                    break;
            }
        }
    }
    setUpForm() {
        this.percentSign = "";
        this.isDaysUntilExpiredOption = false;
        switch (this.statusField) {
            case ApplicationSearchConstants.STATUS:
                this.statusLabel = ApplicationSearchConstants.FORM_CONTROLS.statusLabel;
                break;
            case ApplicationSearchConstants.CATEGORY:
                this.statusLabel = ApplicationSearchConstants.FORM_CONTROLS.categoryLabel;
                break;
            case ApplicationSearchConstants.PERCENT_COMPLETE:
                this.statusLabel = ApplicationSearchConstants.FORM_CONTROLS.percentCompleteLabel;
                this.percentSign = "%";
                break;
            case ApplicationSearchConstants.DAYS_UNTIL_EXPIRED:
                this.statusLabel = ApplicationSearchConstants.FORM_CONTROLS.daysUntilExpiredLabel;
                this.isDaysUntilExpiredOption = true;
                break;
            case ApplicationSearchConstants.TIMEOUT_STATUS:
                this.statusLabel = ApplicationSearchConstants.FORM_CONTROLS.timeoutStatusLabel;
                break;
        }
        if (this.isDaysUntilExpiredOption) {
            this.statusForm = new FormGroup({
                daysUntilExpiredFormControl: new FormControl(0)
            });
        }
        else {
            this.statusForm = new FormGroup({
                statusFormControl: new FormControl("")
            });
            switch (this.statusField) {
                case ApplicationSearchConstants.TIMEOUT_STATUS:
                    this.statusList.push("Active");
                    this.statusList.push("Inactive");
                    break;
                case ApplicationSearchConstants.STATUS:
                case ApplicationSearchConstants.PERCENT_COMPLETE:
                case ApplicationSearchConstants.DAYS_UNTIL_EXPIRED:
                default:
                    this.getStatusForModuleSubscription = this.aflaModuleStrategyService.getStatusForModule(Number(this.appController.selectedModuleID), this.statusField)
                        .subscribe((status) => {
                        this.statusList = status.value.sort((a, b) => 0 - (a > b ? -1 : 1));
                    });
                    break;
            }
        }
    }
    static ctorParameters = () => [
        { type: ApplicationSearchService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: Store }
    ];
    static propDecorators = {
        statusField: [{ type: Input }]
    };
};
SearchStatusComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-search-status",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], SearchStatusComponent);
export { SearchStatusComponent };
